export const deviceOptions = [
  {
    'key': 'S',
    'value': 'S',
    'text': 'SI',
  },
  {
    'key': 'N',
    'value': 'N',
    'text': 'NO',
  },
  {
    'key': 'C',
    'value': 'C',
    'text': 'CUSTODIO',
  },
];
